import { useQuery } from 'react-query';
import * as teamsApi from 'resources/teams/teams.api';

export default function useGetTeamById(teamId, queryOptions = {}) {
  return useQuery(
    ['teams.get-team-by-id', teamId],
    () => teamsApi.getTeamById(teamId),
    queryOptions,
  );
}
